import { type FieldValues, type Path, useFormContext } from "react-hook-form"

type FormFieldProps<TFieldValues extends FieldValues = FieldValues> = {
  description?: string
  label: string
  name: Path<TFieldValues>
  readOnly?: boolean
  rows?: number
  type?: string
}

const FormField = ({
  description,
  label,
  name,
  rows = 0,
  readOnly = false,
  type = "text",
}: FormFieldProps) => {
  const {
    register,
    formState: { errors },
  } = useFormContext()

  const error = errors[name]?.message

  return (
    <label className="flex flex-col gap-2">
      <span className="text-sm font-medium text-foreground">{label}</span>
      {description && (
        <span className="text-xs text-muted-foreground">{description}</span>
      )}
      {rows > 0 ? (
        <textarea
          {...register(name)}
          className="rounded-md border border-border bg-background px-3 py-2 text-sm text-foreground outline-none transition-colors placeholder:text-muted-foreground focus:border-primary read-only:bg-muted"
          readOnly={readOnly}
          rows={rows}
        />
      ) : (
        <input
          {...register(name)}
          className="rounded-md border border-border bg-background px-3 py-2 text-sm text-foreground outline-none transition-colors placeholder:text-muted-foreground focus:border-primary read-only:bg-muted"
          readOnly={readOnly}
          type={type}
        />
      )}
      {error && (
        <span className="text-xs text-destructive">{String(error)}</span>
      )}
    </label>
  )
}

export default FormField
